module.exports = __webpack_public_path__ + "static/media/plusicon.8fc1ac5f.svg";